import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AmbassadorsComponent } from './pages/ambassadors/ambassadors.component';
import { AppComponent } from './app.component';
import { CommissionPlansComponent } from './pages/commission-plans/commission-plans.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HowItWorksComponent } from './pages/how-it-works/how-it-works.component';
import { MarketingResourcesComponent } from './pages/marketing-resources/marketing-resources.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { WhoShouldJoinComponent } from './pages/who-should-join/who-should-join.component';

@NgModule({
  declarations: [AmbassadorsComponent, CommissionPlansComponent, FaqComponent, HowItWorksComponent, MarketingResourcesComponent, WhoShouldJoinComponent, NotFoundComponent, AppComponent],
  imports: [BrowserModule, AppRoutingModule],
  bootstrap: [AppComponent]
})
export class AppModule {}
